import React from 'react';
import { ChevronLeft, ChevronRight, Check, Forward } from 'lucide-react';
import PropTypes from 'prop-types';

const Navigation = ({
    currentIndex,
    totalQuestions,
    onPrevious,
    onNext,
    onReview,
    onSkip,
    saving,
    canProgress,
    showReviewButton,
    currentQuestionType,
    isRangeConfirmed = true,
    isRequired = true
}) => {
    const isLastQuestion = currentIndex === totalQuestions - 1;
    const isRangeQuestion = currentQuestionType === 'range';
    const canProceed = isRangeQuestion ? (canProgress && isRangeConfirmed) : canProgress;

    return (
        <div className="flex justify-between items-center mt-8">
            <button
                onClick={onPrevious}
                disabled={currentIndex === 0 || saving}
                className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                    currentIndex === 0 || saving
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
            >
                <ChevronLeft className="w-4 h-4" />
                Back
            </button>

            <div className="flex gap-3">
                {/* Skip option for non-required questions */}
                {!isRequired && (
                    <button
                        onClick={onSkip}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                    >
                        <Forward className="w-4 h-4" />
                        Skip
                    </button>
                )}

                {/* Show Save & Exit if not on last question */}
                {!isLastQuestion && showReviewButton && (
                    <button
                        onClick={onReview}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                    >
                        Save & Exit
                    </button>
                )}

                {/* Show Next or Complete based on position */}
                <button
                    onClick={onNext}
                    disabled={saving || (!canProceed && isRequired)}
                    className={`flex items-center gap-2 px-6 py-2 text-sm font-medium rounded-md ${
                        saving || (!canProceed && isRequired)
                            ? 'bg-gray-400 text-white cursor-not-allowed'
                            : isLastQuestion
                                ? 'bg-green-600 text-white hover:bg-green-700'
                                : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
                    title={
                        !canProceed && isRequired 
                            ? 'Please provide a valid response'
                            : undefined
                    }
                >
                    {isLastQuestion ? (
                        <>
                            Complete Questionnaire
                            <Check className="w-4 h-4" />
                        </>
                  ) : (
                    <>
                        Next
                        <ChevronRight className="w-4 h-4" />
                    </>
                )}
            </button>
        </div>
    </div>
);
};

Navigation.propTypes = {
currentIndex: PropTypes.number.isRequired,
totalQuestions: PropTypes.number.isRequired,
onPrevious: PropTypes.func.isRequired,
onNext: PropTypes.func.isRequired,
onReview: PropTypes.func.isRequired,
onSkip: PropTypes.func,
saving: PropTypes.bool,
canProgress: PropTypes.bool,
showReviewButton: PropTypes.bool,
currentQuestionType: PropTypes.string,
isRangeConfirmed: PropTypes.bool,
isRequired: PropTypes.bool
};

Navigation.defaultProps = {
saving: false,
canProgress: true,
showReviewButton: false,
isRangeConfirmed: true,
isRequired: true
};

export default Navigation;